import { ImageGallery } from '../../Components/ImageGallery/ImageGallery'

export const GalleryPage = () => {
    return (
        <>
            <h1 style={{ margin: "0", paddingTop: "90px" }} className="page_title">Events Gallery</h1>
            <ImageGallery />
        </>
    )
}
